import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ReactTable from "react-table";
import "react-table/react-table.css";
import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
import {ToastsContainer, ToastsStore} from 'react-toasts';
import Spinner from 'react-spinner-material';
import queryString from 'query-string'

import { FaFilter } from 'react-icons/fa';
import { MdFileUpload, MdImportExport, MdFileDownload, MdDeleteForever } from 'react-icons/md';
import Dialog from 'react-bootstrap-dialog';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import "react-table/react-table.css";
import "../css/style.css";

import MenuComponent2 from './MenuComponent2';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import WorkOrderDataService from '../services/WorkOrderDataService';
import MasterDataService from '../services/MasterDataService';
import AuthenticationService from '../services/AuthenticationService';
import { ICON_COLOR} from '../icon';
import QualityReportListView from './QualityReportListView';
import { SERVER_URL } from '../constants';
import DataUtil from '../utilities/DataUtil';
import UserDataService from '../services/UserDataService';

class QualityReport extends Component {
  constructor () {
    super();
    this.fileInputRef = React.createRef();
    const numOfMonths = 24;
    let fromDate = new Date(new Date().getTime() - numOfMonths*30*24*60*60*1000*3);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    let toDate = new Date();
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    this.state = {
      spinnerVisible: false,
      fromDate: fromDate,
      toDate: toDate,
      orderNo: null,
      pageSize: 10,
      page: 0,     
      qualityReports: [],
      childRefreshCount: 0,
      show2: false,
      workOrder: {},
      tinhTrangSuCos: [],
      loaiSuCos: [
      ],
      workers: [],
      selectedRow: 0,
      selected: 0,
      childRefreshCount: 0,
      columns: [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row => (
            <div style={{ padding: "10px" }}>{row.index + 1}</div>
          )
        },
        {
          id: "checkbox",
          accessor: "",
          Cell: ({ original }) => {
            return (
              <div style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={this.state.selected[original.id] === true}
                  onChange={() => this.toggleRow(original.id)}
                /></div>
            );
          },
          Header: x => {
            return (
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selectAll === 1}
                ref={input => {
                  if (input) {
                    input.indeterminate = this.state.selectAll === 2;
                  }
                }}
                onChange={() => this.toggleSelectAll()}
              />
            );
          },
          sortable: false,
          width: 45
        },
        {
          Header: couterpart.translate('quality_sodh'),
          accessor: 'soDh',
          width: 150,
          Cell: row => (
            this.linkToDetails(row)
          )
        }, {
          Header: couterpart.translate('quality_masx'),
          width: 150,
          accessor: 'maSx',
          filterable: false
        }, {
          Header: couterpart.translate('quality_ngayshipvn'),
          width: 150,
          accessor: 'ngayShipVn',
          filterable: false
        }, {
          Header: couterpart.translate('quality_ngaykhnhan'),
          width: 150,
          accessor: 'ngayKhNhanHang',
          filterable: false
        }, {
          Header: couterpart.translate('quality_ngaysuco'),
          width: 150,
          accessor: 'ngaySuCo',
          filterable: false
        }, {
          Header: couterpart.translate('quality_ngayreport'),
          width: 150,
          accessor: 'createdAt',
          filterable: false
        }, {
          Header: couterpart.translate('quality_loaisuco'),
          width: 150,
          accessor: 'loaiSuCo',
          filterable: false,
          Cell: props => this.getLoaiSuCoDescription(props.value)
        }, {
          Header: couterpart.translate('quality_motasuco'),
          width: 150,
          accessor: 'moTaSuCo',
          filterable: false
        }, {
          Header: couterpart.translate('quality_copyhasuco'),
          width: 250,
          accessor: 'hinhAnhSuCo',
          Cell: row => (
            this.linkToImage(row)
          )
        }, {
          Header: couterpart.translate('quality_tho'),
          width: 250,
          accessor: 'tho',
          Cell: props => this.getWorkerById(props.value)
        }, {
          Header: couterpart.translate('quality_nguyennhan'),
          width: 150,
          accessor: 'nguyenNhan',
          filterable: false
        }, {
          Header: couterpart.translate('quality_giaiphap'),
          width: 150,
          accessor: 'giaiPhap',
          filterable: false
        }, {
          Header: couterpart.translate('quality_tinhtrangsuco'),
          width: 150,
          accessor: 'tinhTrang',
          filterable: false,
          Cell: props => this.getTinhTrangDescription(props.value)
        }, {
          Header: couterpart.translate('quality_action'),
          accessor: 'action',
          width: 150,
          Cell: row => (
            <div style={{ textAlign: "center" }}>
              {this.renderEditButton(row)}
            </div>
          )
      }]
    };
  }

  renderEditButton(row) {
    const button_delete = couterpart.translate('button_delete');
    if (AuthenticationService.isAdmin() || AuthenticationService.isService()) {
      return (<div>
        <button className="myButton" onClick={() => this.handleDelete(row)}>
          <MdDeleteForever color={ICON_COLOR} />
          &nbsp;{button_delete}</button>
      </div>
      );
    } else {
      return (<></>);
    }
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state,callback)=>{
        return;
    };
  }

  componentDidMount () {
    //var decodedStringAtoB = atob(encodedStringAtoB);
    const values = queryString.parse(this.props.location.search);
    let encodedSoDh = values.soDh;
    let soDh = "";
    if (encodedSoDh !== undefined){
      soDh = atob(encodedSoDh);
      this.setState({
        soDh: soDh,
        show2: true
      }, () => {
        this.filterWorkOrdersByNo();
      });
    }
    this.loadLoaiSuCos();
    this.loadTinhTrangSuCos();
    this.loadWorkers();

    const numOfMonths = 12;
    let fromDate = new Date(new Date().getTime() - numOfMonths*30*24*60*60*1000*1);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    let toDate = new Date(new Date().getTime() + 24*60*60*1000*1);
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
    let pageSize = 10;
    try {
      pageSize = parseInt(WorkOrderUtil.getItem('qualityReport.pageSize'));
      if (isNaN(pageSize) || pageSize < 1) {
        pageSize = 10;
      }
    } catch (eps) {
      pageSize = 10;
    }
    this.setState({ 
      fromDate:  fromDate, 
      toDate: toDate, 
      orderNo: WorkOrderUtil.getItem("qualityReport.orderNo"),
      pageSize: pageSize,
    }, () => {
      this.filterQualityReportsBy();
    });
  
  }

  handleEdit(row) {
    this.editSuCo(row.original);
  }

  handleDelete(row) {
    this.deleteSuCo(row.original.id);
  }

  linkToDetails(row) {
    return (
      <label className="label_link" href="#!" onClick={() => { this.handleEdit(row) }}>{row.original.soDh}</label>
    )
  }

  getHinhAnhSuCos(fileNames){
    let arr = fileNames.split(",");
    return arr;
  }

  getHinhAnhSuCoFileName(fileName, soDh){
    if (soDh === undefined){
      return "";
    }
    let s = SERVER_URL + "/" + soDh.replace("/", "_") + this.changeExt(fileName);
    return s;
  }

  linkToImage(row) {
    let images = this.getHinhAnhSuCos(row.original.hinhAnhSuCo);
    return(
      <>{ images !== undefined && images.map(image => this.renderHinhAnhSuCo(image, this.getHinhAnhSuCoFileName(image, row.original.soDh))) }</>
    );
  }
  renderHinhAnhSuCo(image, fileName){
    return (<><a href={ fileName } target="_blank">{image}</a><br/></>);
  }

  changeExt(name){
    if (name === undefined){
      return "";
    }
    let idx = name.lastIndexOf(".");
    return name.substring(0, idx) + ".jpg";
  }

  loadLoaiSuCos(){
    MasterDataService.retrieveQualityIncidents().then(data => {
        this.setState({ 
          loaiSuCos:  data
        });
    });
  }

  loadTinhTrangSuCos(){
    MasterDataService.retrieveQualityStatuses().then(data => {
        this.setState({ 
          tinhTrangSuCos:  data
        });
    });
  }

  loadWorkers() {
    if (AuthenticationService.isAdmin() || AuthenticationService.isService() || AuthenticationService.isKhac() || AuthenticationService.isSupervisor()  || AuthenticationService.isQuality()) {
      UserDataService.retrieveWorkers().then(data => {
        this.setState({ workers: data });
      });
    }
  }

  getWorkerById(workerId){
    if (workerId === undefined) {
      return "";
    }
    
    if (this.state.workers === undefined || this.state.workers === null){
      return "";
    }
    let worker = this.state.workers.filter(x => {
      let iworkerId = parseInt(workerId);
      return x.id === iworkerId;
    });

    if (worker === undefined || worker === null || worker.length <= 0){
      return workerId;
    }
    return worker[0].userName;
  }

  toggleRow(id) {
		const newSelected = Object.assign({}, this.state.selected);
		newSelected[id] = !this.state.selected[id];
		this.setState({
			selected: newSelected,
			selectAll: 2
		});
	}

  utcToLocal(utcDate){
    return new Date(utcDate).toDateString();
  }

  getTinhTrangDescription(tinhTrang){
    if (this.state.tinhTrangSuCos === undefined || this.state.tinhTrangSuCos === null){
        return tinhTrang;
    }    
    let tt = this.state.tinhTrangSuCos.find(x =>{
      return x.id === tinhTrang;
    });

    if (tt !== undefined){
      return tt.details;
    }   
    return tinhTrang;     
  }

  getLoaiSuCoDescription(loaiSuCo){
    if (this.state.loaiSuCos === undefined || this.state.loaiSuCos === null){
        return loaiSuCo;
    }    
    let tt = this.state.loaiSuCos.find(x =>{
      return x.id === loaiSuCo;
    });

    if (tt !== undefined){
      return tt.details;
    }   
    return loaiSuCo;     
  }

  clearSearchInfo() {
    WorkOrderUtil.removeItem("qualityReport.fromDate");
    WorkOrderUtil.removeItem("qualityReport.toDate");
    WorkOrderUtil.removeItem("qualityReport.orderNo");
    WorkOrderUtil.removeItem("qualityReport.pcode");
    WorkOrderUtil.removeItem("qualityReport.pageSize");
    WorkOrderUtil.removeItem("qualityReport.page");
  }
  saveSearchInfo(fromDate, toDate, orderNo, pcode, pageSize, page){
    WorkOrderUtil.saveItem("qualityReport.fromDate", fromDate);
    WorkOrderUtil.saveItem("qualityReport.toDate", toDate);
    WorkOrderUtil.saveItem("qualityReport.orderNo", orderNo);
    WorkOrderUtil.saveItem("qualityReport.pcode", pcode);
    WorkOrderUtil.saveItem("qualityReport.pageSize", pageSize);
    WorkOrderUtil.saveItem("qualityReport.page", page);
  }

  onFilter() {
    this.clearSearchInfo();
    this.filterQualityReportsBy();
  }

  onExport() {
    this.exportQualityReportsBy();
  }  

  filterQualityReportsBy(){   
    let fromDate = this.state.fromDate;
    let toDate = this.state.toDate;
    let orderNo = this.state.orderNo;
    let pcode = this.state.pcode;
    let tinhTrang = this.state.tinhTrangFilter;
    let loaiSuCo = this.state.loaiSuCoFilter;

    if ((this.state.selectedPage < 0) || (this.state.pageSize < 0)){
      return;
      }

      this.setState({ loading: true });
      let page = this.state.selectedPage === undefined? 0: this.state.selectedPage;
      let pageSize = this.state.pageSize === undefined? 10: this.state.pageSize;   

      
      this.saveSearchInfo(fromDate, toDate, pcode, pageSize, page);
      WorkOrderDataService.fetchQualityReports(page, pageSize, fromDate, toDate, orderNo, pcode, tinhTrang, loaiSuCo)
      .then(data => { 

        console.log(data);
        if(data !== undefined && data.message === undefined &&  data.qualityReports instanceof Array){
          this.setState({ qualityReports: data.qualityReports, spinnerVisible: false, loading: false, pages: data.totalPages, page: data.currentPage, pageSize: pageSize});
        }else{
          this.setState({ qualityReports: [], loading: false, pages: 0, page: 0, pageSize: pageSize});
        }   
    });
  }

  exportQualityReportsBy(){   
    let fromDate = this.state.fromDate;
    let toDate = this.state.toDate;
    let orderNo = this.state.orderNo;
    let pcode = this.state.pcode;
    let tinhTrang = this.state.tinhTrangFilter;
    let loaiSuCo = this.state.loaiSuCoFilter;

    if ((this.state.selectedPage < 0) || (this.state.pageSize < 0)){
      return;
      }

      this.setState({ loading: true });

      WorkOrderDataService.exportQualityReports(fromDate, toDate, orderNo, pcode, tinhTrang, loaiSuCo)
      .then(data => { 
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', "QualityReports_" + fromDate + "_" + toDate + ".xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        DataUtil.sleep(1000).then(() => { this.setState({ loading: false }); });
    });
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  nhapSuCo () {
    try{
      this.setState({spinnerVisible: true, show2: true, workOrder: {}, 
        id: 0,
        soDh: '',
        shipAt: '',
        tho: '',
        maSx: '',
        ngayKhNhanHang: '', 
        ngaySuCo: '', 
        moTaSuCo: '', 
        nguyenNhan: '', 
        giaiPhap: '', 
        selectedFilenames: '',
        loaiSuCo: 0,
        tinhTrang: 0}, () =>{
        this.sleep(100).then(() => {
          this.setState({spinnerVisible: false});
          if (this.fileInputRef.current) {
            this.fileInputRef.current.value = "";
            this.fileInputRef.current.type = "text";
            this.fileInputRef.current.type = "file";
          }
        });
      });
    } catch(e) {
      this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
    }
  }

  editSuCo (suco) {
    try{
      this.setState({spinnerVisible: true, show2: true, 
        workOrder: {
          workOrderNo: suco.soDh,
          shipAt: suco.ngayShipVn,
          fullPCode: suco.maSx,
          worker: suco.tho 
        },
        id: suco.id, 
        soDh: suco.soDh,
        ngayKhNhanHang: suco.ngayKhNhanHang, 
        ngaySuCo: suco.ngaySuCo, 
        moTaSuCo: suco.moTaSuCo, 
        nguyenNhan: suco.nguyenNhan, 
        giaiPhap: suco.giaiPhap, 
        selectedFilenames: suco.hinhAnhSuCo,
        loaiSuCo: suco.loaiSuCo,
        tinhTrang: suco.tinhTrang}, () =>{
        this.sleep(100).then(() => {
          this.setState({spinnerVisible: false});
          console.log(suco);
        });
      });
    } catch(e) {
      this.sleep(100).then(() => {this.setState({spinnerVisible: false});});
    }
  }

  deleteSuCo(id){
    let ret = window.confirm(couterpart.translate('quality_xoa_confirm_msg'));
    if (ret === true) {
      WorkOrderDataService.deleteQualityReport(id).then(data => {
        if (data !== undefined && data !== null && data === 1) {
            this.filterQualityReportsBy();
        } else {
            alert("Không thể xóa dữ liệu.")
        }
      });
    }
  }

  handleFromDateChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      fromDate: sDate                   
    });
  }

  handleToDateChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      toDate: sDate                   
    });
  }

  handleNgayKhNhanHangChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      ngayKhNhanHang: sDate                   
    });
  }

  handleNgaySuCoChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      ngaySuCo: sDate                   
    });
  }

  handleOrderNoChange(e){
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }    
    let value = e.target.value;
    this.setState({                 
      orderNo: value                   
    });
  }

  handlePcodeChange(e){
    if (e.key === 'Enter') {
      this.onFilter()
      return;
    }    
    let value = e.target.value;
    this.setState({                 
      pcode: value                   
    });
  }

  handleKeyDown(e){
      if (e.key === 'Enter') {
          this.onFilter()
      }
  }  

  renderProductList () {
    console.log(this.state.pageSize);
    return(<>
      <ReactTable
        manual={true}
        NoDataComponent={() => null}
        previousText={"<"}
        nextText={">"}
        page={this.state.page}
        pages={this.state.pages}
        onPageChange={pageIndex => {
          this.setState({ selectedPage: pageIndex }, () => {
            this.filterQualityReportsBy()
          })
        }}
        onPageSizeChange={(pageSize, pageIndex) => {
          console.log("pageSize: " + pageSize);
          this.setState({ page: pageIndex, pageSize: pageSize }, () => {
            this.filterQualityReportsBy()
          });
        }}
        data={this.state.qualityReports}
        columns={this.state.columns}
        defaultPageSize={this.state.pageSize}
        showPageSizeOptions={true}
        pageSizeOptions={[5, 10, 20, 50]}
        getTrProps={(state, rowInfo, column) => {
          if (rowInfo && rowInfo.row) {
            return {
              onClick: (e) => {
                this.setState({
                  selectedRow: rowInfo.index,
                  workOrderId: rowInfo.original.id
                }, () => {
                  WorkOrderUtil.saveItem('qualityReport.selectedRow', this.state.selectedRow);
                })
              },
              style: {
                background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                color: rowInfo.index === this.state.selectedRow ? 'white' : 'black'
              }
            }
          } else {
            return {}
          }
        }
        }
        onSortedChange={(c, s) => {
        }}
      />
    </>);
  }

  handleClose(){
    this.setState({ show2: false });
  }

  handleOrderNoChange(e){
    var value = e.target.value;
    console.log(value);
    sessionStorage.setItem("qualityReport.orderNo", value)
    this.setState(prevState => ({                 
        orderNo: value                   
    }));
  }

  handleSoDhChange(e){
    var value = e.target.value;
    this.setState({                 
        soDh: value                   
    });
  }

  handleKeyDown(e){
    console.log(e);
    if (e.key === 'Enter') {
      this.processOrder()
    }
  }

  processOrder(){
    let orderNo = this.state.soDh;
      if (orderNo !== undefined && orderNo.trim().length > 0){
          this.filterWorkOrdersByNo()
      }
  }

  filterWorkOrdersByNo(){   
    var no = this.state.soDh;
    if (no === undefined || no === null){
        return;
    }

    WorkOrderDataService.scanByNo(`${no}`).then(data => {
        if (data !== undefined && data !== null && data.status !== undefined) {
            this.setState({ 
                workOrderId: data.id,
                workOrder:  data,
                shipAt: data.shipAt
            });
        } else {
            alert("Đơn hàng không hợp lệ.")
        }
    });
  }

  renderTinhTrangSuCo4Filter() {
    if ((this.state.tinhTrangSuCos === undefined) || (this.state.tinhTrangSuCos === null)) {
      return (<></>);
    }
    return (
      <select onChange={this.handleTinhTrangFilterChange.bind(this)} style={{ padding: '1px', marginTop: '5px' }} className="field_margin_w100" defaultValue={ this.state.tinhTrangFilter }>
        <option key={"tinhTrangSuCo_0"} value={0}></option>
        {this.state.tinhTrangSuCos !== undefined && this.state.tinhTrangSuCos.map(option => this.renderTinhTrangSuCoFilterOption(option))}
      </select>
    );
  }

  renderTinhTrangSuCo() {
    if ((this.state.tinhTrangSuCos === undefined) || (this.state.tinhTrangSuCos === null)) {
      return (<></>);
    }
    return (
      <select onChange={this.handleSelectChange.bind(this)} style={{ padding: '1px', marginTop: '5px' }} className="field_margin_w100" defaultValue={ this.state.tinhTrang }>
        <option key={"tinhTrangSuCo_0"} value={0}></option>
        {this.state.tinhTrangSuCos !== undefined && this.state.tinhTrangSuCos.map(option => this.renderTinhTrangSuCoOption(option))}
      </select>
    );
  }

  renderLoaiSuCo() {
    if ((this.state.loaiSuCos === undefined) || (this.state.loaiSuCos === null)) {
      return (<></>);
    }
    return (
      <select onChange={this.handleSelectLoaiSuCoChange.bind(this)} style={{ padding: '1px', marginTop: '5px' }} className="field_margin_w100" defaultValue={ this.state.loaiSuCo }>
        <option key={"loaiSuCo_0"} value={0}></option>
        {this.state.loaiSuCos !== undefined && this.state.loaiSuCos.map(option => this.renderLoaiSuCoOption(option))}
      </select>
    );
  }

  renderLoaiSuCoFilter() {
    if ((this.state.loaiSuCos === undefined) || (this.state.loaiSuCos === null)) {
      return (<></>);
    }
    return (
      <select onChange={this.handleSelectLoaiSuCoFilterChange.bind(this)} style={{ padding: '1px', marginTop: '5px' }} className="field_margin_w100" defaultValue={ this.state.loaiSuCoFilter }>
        <option key={"loaiSuCoFilter_0"} value={0}></option>
        {this.state.loaiSuCos !== undefined && this.state.loaiSuCos.map(option => this.renderLoaiSuCoFilterOption(option))}
      </select>
    );
  }

  renderTinhTrangSuCoOption(option) {
    return (
      <option key={"tinhTrangSuCo_" + option.id} value={option.id}>{option.details}</option>
    );
  }

  renderTinhTrangSuCoFilterOption(option) {
    return (
      <option key={"tinhTrangSuCoFilter_" + option.id} value={option.id}>{option.details}</option>
    );
  }

  renderLoaiSuCoOption(option) {
    return (
      <option key={"loaiSuCo_" + option.id} value={option.id}>{option.details}</option>
    );
  }

  renderLoaiSuCoFilterOption(option) {
    return (
      <option key={"loaiSuCoFilter_" + option.id} value={option.id}>{option.details}</option>
    );
  }

  handleSelectChange(e) {
    var value = e.target[e.target.selectedIndex].value;
    this.setState({
      tinhTrang: value
    });
  };

  handleTinhTrangFilterChange(e) {
    var value = e.target[e.target.selectedIndex].value;
    this.setState({
      tinhTrangFilter: value
    });
  };


  handleSelectLoaiSuCoChange(e) {
    var value = e.target[e.target.selectedIndex].value;
    this.setState({
      loaiSuCo: value
    });
  };

  handleSelectLoaiSuCoFilterChange(e) {
    var value = e.target[e.target.selectedIndex].value;
    this.setState({
      loaiSuCoFilter: value
    });
  };

  handleFile(e){
      let file = e.target.files;
      this.setState({file}, ()=>{
          if (file != null && file.length > 0){
              var selectedFiles = "";
              var fileSep = "";
              for(var i=0; i<file.length;i++){
                  selectedFiles += fileSep + file[i].name;
                  fileSep = ",";
              }
              
              this.setState({
                  selectedFilenames: selectedFiles
              });
          }
      });
  }

  handleUpload(e){
    let files = this.state.file;
    let msg = "";
    try{
      if (this.state.workOrder.workOrderNo === null || this.state.workOrder.workOrderNo === undefined || this.state.workOrder.workOrderNo.trim().length < 10){
        alert("Thiếu số đơn hàng");
        return;
      }

      if (this.state.workOrder.shipAt === null || this.state.workOrder.shipAt === undefined || this.state.workOrder.shipAt.trim().length < 10){
        alert("Thiếu ngày ship hàng từ ViệtNam");
        return;
      }


      if (this.state.ngayKhNhanHang === null || this.state.ngayKhNhanHang === undefined || this.state.ngayKhNhanHang.trim().length < 10){
        alert("Thiếu ngày khách hàng nhận hàng");
        return;
      }

      if (this.state.ngaySuCo === null || this.state.ngaySuCo === undefined || this.state.ngaySuCo.trim().length < 10){
        alert("Thiếu ngày sự cố");
        return;
      }

      if (this.state.loaiSuCo === null || this.state.loaiSuCo=== undefined || this.state.loaiSuCo < 1){
        alert("Thiếu loại sự cố");
        return;
      }

      if (this.state.selectedFilenames === null || this.state.selectedFilenames=== undefined || this.state.selectedFilenames.trim().length < 1){
        alert("Thiếu hình ảnh sự cố");
        return;
      }

      if (this.state.tinhTrang === null || this.state.tinhTrang=== undefined || this.state.tinhTrang < 1){
        alert("Thiếu tình trạng sự cố");
        return;
      }

      this.setState({spinnerVisible: true}, () =>{
          if (((files === null) || (files === undefined) || (files.length < 1)) && (this.state.selectedFilenames === null || this.state.selectedFilenames === undefined || this.state.selectedFilenames.trim().length < 1)){
              msg = couterpart.translate("msg_upload_validate_file");
              ToastsStore.error(msg);
              this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
              return;
          }

          if (files != null || (this.state.selectedFilenames !== null && this.state.selectedFilenames !== undefined && this.state.selectedFilenames.trim().length > 1)){
            let info = {
              id: this.state.id,
              woNo: this.state.workOrder.workOrderNo,
              tho: this.state.workOrder.worker,
              maSx: this.state.workOrder.fullPCode,
              ngayShipVn: this.state.workOrder.shipAt,
              ngayKhNhanHang: this.state.ngayKhNhanHang,
              ngaySuCo: this.state.ngaySuCo,
              loaiSuCo: this.state.loaiSuCo === undefined || this.state.loaiSuCo == null? 999 : this.state.loaiSuCo,
              moTaSuCo: this.state.moTaSuCo,
              hinhAnhSuCo: this.state.selectedFilenames,
              nguyenNhan: this.state.nguyenNhan,
              giaiPhap: this.state.giaiPhap,
              tinhTrang: this.state.tinhTrang === undefined || this.state.tinhTrang == null? 999 : this.state.tinhTrang
            };
            WorkOrderDataService.uploadQualityReport(files, info).then(response => {
              if (response.length !== undefined && response.indexOf("so_dh_UNIQUE")){
                alert("Đơn hàng đã được báo lỗi");
              } else {
                this.sleep(1000).then(() => {
                  this.filterQualityReportsBy();
                  this.setState({spinnerVisible: false, show2: false});
                });
              }
            });
          }
      });
    }catch(e){
        this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
    }            
  }

  handleLoaiSuCoChange(e){
    var value = e.target.value;
    this.setState(prevState => ({                 
        loaiSuCo: value                   
    }));
  }

  handleMoTaSuCoChange(e){
    var value = e.target.value;
    this.setState(prevState => ({                 
        moTaSuCo: value                   
    }));
  }

  handleThoChange(e){
    var value = e.target.value;
    this.setState(prevState => ({                 
        tho: value                   
    }));
  }

  handleNguyenNhanChange(e){
    var value = e.target.value;
    this.setState(prevState => ({                 
        nguyenNhan: value                   
    }));
  }

  handleGiaiPhapChange(e){
    var value = e.target.value;
    this.setState(prevState => ({                 
        giaiPhap: value                   
    }));
  }

  changeExt(name){
    let idx = name.lastIndexOf(".");
    return name.substring(0, idx) + ".jpg";
  }

  getImages(){
    let fileNames = this.state.selectedFilenames === undefined? "" : this.state.selectedFilenames;
    let arr = fileNames.split(",");
    return arr;
  }

  getFileName(fileName){
    if (this.state.soDh === undefined){
      return "";
    }
    let s = SERVER_URL + "/" + this.state.soDh.replace("/", "_") + this.changeExt(fileName);
    console.log(s);
    return s;
  }

  renderImageViewer(){
    let images = this.getImages();
    if (this.state.id > 0){
      return(
        <div className='row'>
            { images !== undefined && images.map(image => this.renderImage(this.getFileName(image))) }
        </div>
      );
    }
    return (<></>);
  }

  renderImage(fileName){
    return (<div className='col-2' key={ fileName }><img src={ fileName } width={100} height={100} /></div>);
  }

  // renderLoaiSuCo() {
  //   if ((this.state.loaiSuCos === undefined) || (this.state.loaiSuCos === null)) {
  //     return (<></>);
  //   }
  //   return (
  //     <select onChange={this.handleSelectLoaiSuCoChange.bind(this)} style={{ padding: '1px', marginTop: '5px' }} className="field_margin_w100" defaultValue={ this.state.loaiSuCo }>
  //       <option key={"loaiSuCo_0"} value={0}></option>
  //       {this.state.loaiSuCos !== undefined && this.state.loaiSuCos.map(option => this.renderLoaiSuCoOption(option))}
  //     </select>
  //   );
  // }

  handleLoadClicked(e){
    this.processOrder();
  }

  render() {
    if (!AuthenticationService.isQuality() && !AuthenticationService.isService()){
      return (<div>Unauthorized access.</div>);
    }

    return (
          <div>
              <MenuComponent2/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <br/>
              <div className="row">
                <div className="col-6 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                  <div className="row">
                    <div className="col-2">
                      <label className="fixlen_t"><b>{couterpart.translate('quality_from_report_date')}</b></label>
                    </div>
                    <div className="col-3">
                      <div className="customDatePickerWidth">
                        <DatePicker name="orderDateFrom" className='field_margin_w100' 
                          dateFormat="MM/dd/yyyy hh:mm"              
                          selected={ WorkOrderUtil.convertToDate(this.state.fromDate)}
                          onChange={this.handleFromDateChange.bind(this)}/>
                      </div>
                    </div>
                    <div className="col-2"><label className="fixlen_t"><b>{couterpart.translate('quality_to_report_date')}</b></label></div>
                    <div className="col-3">
                      <div className="customDatePickerWidth">
                        <DatePicker name="orderDateTo" className='field_margin_w100'
                          dateFormat="MM/dd/yyyy hh:mm"
                          selected={ WorkOrderUtil.convertToDate(this.state.toDate)}
                          onChange={this.handleToDateChange.bind(this)}/>
                        </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-2">
                      <label className="fixlen_t"><b>{couterpart.translate('quality_tinhtrang_filter')}</b></label>
                    </div>
                    <div className="col-3">
                      { this.renderTinhTrangSuCo4Filter() }
                    </div>
                    <div className="col-2">
                      <label className="fixlen_t"><b>{couterpart.translate('quality_loaisuco_filter')}</b></label>
                    </div>
                    <div className="col-3">
                      { this.renderLoaiSuCoFilter() }
                    </div>
                  </div>
                </div> 
                <div className="col-6 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                  <div className="row">
                    <div className='col-6'>
                      <div className='row'>
                        <div className="col-4">
                          <input type="text" defaultValue={this.state.orderNo} className='field_margin_w100' id="orderNo1"
                            placeholder={couterpart.translate('order_no')}
                            onChange={this.handleOrderNoChange.bind(this)}/>
                        </div>
                        <div className="col-4">
                          <input type="text" defaultValue={this.state.pcode} className='field_margin_w100' id="pcode" 
                            placeholder={couterpart.translate('shop_pcode')}
                            onChange={this.handlePcodeChange.bind(this)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-2">
                      <button className="myButton0" onClick={this.onFilter.bind(this)}  style={{ width: "100%", marginTop: "5px"}}><FaFilter color={ICON_COLOR}/>&nbsp;{couterpart.translate('button_filter')}</button>
                    </div>
                    <div className='col-2'>
                      <button className="myButton0" onClick={this.nhapSuCo.bind(this)}  style={{ width: "100%", marginTop: "5px"}}><MdImportExport color={ICON_COLOR}/>&nbsp;{couterpart.translate('quality_them_report')}</button>
                    </div>
                    <div className='col-2'>
                      <button className="myButton0" onClick={this.onExport.bind(this)}  style={{ width: "100%", marginTop: "5px"}}><MdFileDownload color={ICON_COLOR}/>&nbsp;{couterpart.translate('quality_export_report')}</button>
                    </div>
                  </div>
                </div>                
              </div>
              { this.renderProductList() }
              
              <Modal show={this.state.show2} onHide={this.handleClose.bind(this)} backdrop="static"  dialogClassName='modal-60w'>
                  <Modal.Header closeButton style={{ background: 'lightblue'}}>
                      <Modal.Title>{ this.state.id > 0? "CẬP NHẬT SỰ CỐ" : "NHẬP SỰ CỐ" }</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                      <div className="row">
                          <div className="col-3">
                              <label className="fixlen">{ "ID" } : </label>
                          </div>                        
                          <div className="col-3">
                              <label className="fixlen field_margin_w100">{ this.state.id } </label>
                          </div>
                      </div>                    
                      <div className="row">
                          <div className="col-3">
                              <label className="fixlen">{ couterpart.translate('quality_sodh') } (*) : </label>
                          </div>                        
                          <div className="col-2">
                              <input type="text" name="soDh" className="inputBox3 field_margin_w100" defaultValue={ this.state.soDh } readOnly={ this.state.id > 0? true : false}
                                onChange={this.handleSoDhChange.bind(this)} onKeyDown={this.handleKeyDown.bind(this)}
                              />
                          </div>
                          <div className='col-1'><button className="myButton0" onClick={this.handleLoadClicked.bind(this) }  style={{ marginTop: "5px"}}>{couterpart.translate('quality_load')}</button></div>
                          <div className="col-3">
                              <label className="fixlen">{ couterpart.translate('quality_masx') } : </label>
                          </div>                        
                          <div className="col-3">
                              <input type="text" name="maSx" className="inputBox3 field_margin_w100" defaultValue={ this.state.workOrder.fullPCode }  readOnly={ true }
                              />
                          </div>
                      </div>
                      <div className="row">
                          <div className="col-3">
                              <label className="fixlen">{ couterpart.translate('quality_ngayshipvn') } (*) : </label>
                          </div>                        
                          <div className="col-3">
                              <input type="text" name="ngayShipVn" className="inputBox3 field_margin_w100" defaultValue={ this.state.workOrder.shipAt } readOnly
                              />
                          </div>
                          <div className="col-3">
                              <label className="fixlen">{ couterpart.translate('quality_ngaykhnhan') } (*) :  </label>
                          </div>                        
                          <div className="col-3">
                            <DatePicker name="ngayKhNhanHang" className='field_margin_w100'
                              dateFormat="MM/dd/yyyy hh:mm"              
                              selected={ WorkOrderUtil.convertToDate(this.state.ngayKhNhanHang)}
                              onChange={this.handleNgayKhNhanHangChange.bind(this)}/>
                          </div>
                      </div>
                      <div className="row">
                          <div className="col-3">
                              <label className="fixlen">{ couterpart.translate('quality_ngaysuco') } (*) : </label>
                          </div>                        
                          <div className="col-3">
                            <DatePicker name="ngaySuCo" className='field_margin_w100'
                              dateFormat="MM/dd/yyyy hh:mm"              
                              selected={ WorkOrderUtil.convertToDate(this.state.ngaySuCo)}
                              onChange={this.handleNgaySuCoChange.bind(this)}/>
                          </div>
                          <div className="col-3">
                              <label className="fixlen">{ couterpart.translate('quality_loaisuco') } : </label>
                          </div>                        
                          <div className="col-3">
                            { this.renderLoaiSuCo() }
                          </div>
                      </div>
                      <div className="row">
                          <div className="col-3">
                              <label className="fixlen">{ couterpart.translate('quality_motasuco') } : </label>
                          </div>                        
                          <div className="col-9">
                              <input type="text" name="moTaSuCo" className="inputBox3 field_margin_w100" defaultValue={ this.state.moTaSuCo }
                               onChange={this.handleMoTaSuCoChange.bind(this)}
                              />
                          </div>
                      </div>
                      <div className="row">
                          <div className="col-3">
                              <label className="fixlen">{ couterpart.translate('quality_copyhasuco') } : </label>
                          </div>                        
                          <div className="col-9">
                            <label htmlFor="file"><MdFileUpload color="green" className='field_margin' style={{ marginTop: '10px'}}/> {this.state.selectedFilenames}</label>
                            <input ref={this.fileInputRef} type="file" name="file" id="file" onChange={(e) => this.handleFile(e)} className='field_margin_w100' multiple/>
                          </div>
                      </div>
                      <div className='row'>
                        <div className='col-12'>
                          { this.renderImageViewer() }
                        </div>
                      </div>
                      <div className="row">
                          <div className="col-3">
                              <label className="fixlen">{ couterpart.translate('quality_nguyennhan') } : </label>
                          </div>                        
                          <div className="col-3">
                              <input type="text" name="nguyenNhan" className="inputBox3 field_margin_w100" defaultValue={ this.state.nguyenNhan } 
                               onChange={this.handleNguyenNhanChange.bind(this)}
                              />
                          </div>
                          <div className="col-3">
                              <label className="fixlen">{ couterpart.translate('quality_giaiphap') } : </label>
                          </div>                        
                          <div className="col-3">
                              <input type="text" name="giaiPhap" className="inputBox3 field_margin_w100" defaultValue={ this.state.giaiPhap } 
                               onChange={this.handleGiaiPhapChange.bind(this)}
                              />
                          </div>
                      </div>
                      <div className="row">
                          <div className="col-3">
                              <label className="fixlen">{ couterpart.translate('quality_tinhtrangsuco') } : </label>
                          </div>                        
                          <div className="col-3">
                              { this.renderTinhTrangSuCo() }
                          </div>
                          <div className="col-3">
                              <label className="fixlen">{ couterpart.translate('quality_tho') } : </label>
                          </div>                        
                          <div className="col-3">
                              <input type="text" name="tho" className="inputBox3 field_margin_w100" defaultValue={ this.getWorkerById(this.state.workOrder.worker) } readOnly
                              />
                          </div>
                      </div>                      
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={this.handleClose.bind(this)}>Cancel</Button>
                    <Button variant="primary" onClick={ this.handleUpload.bind(this) }>OK</Button>  
                  </Modal.Footer>
              </Modal>

              <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
              <Dialog ref={(component) => { this.dialog = component }} />
          </div>      
    )
  }
}
export default withRouter(QualityReport);